import PubSub from 'underpub-js';
import gsap from 'gsap';

var NavigationPopup = function (options) {
  this.options = {
    $el: false,
    baseClass: 'mol-NavigationPopup',
  };

  $.extend(true, this.options, options);
};

NavigationPopup.prototype.init = function () {
  const self = this;

  self.$hamburger = $('.atom-Hamburger');

  self.$inner = self.options.$el.find(`.${self.options.baseClass}__inner`);
  self.$overlay = self.options.$el.next(`.${self.options.baseClass}__overlay`);

  self.initAnimation();

  PubSub.subscribe('NavigationPopup__toggle', () => self.toggle());
  PubSub.subscribe('NavigationPopup__toggleOff', () => self.toggleOff());
  PubSub.subscribe('Sitewide__resize', () => self.toggleOff())
  self.$overlay.on('click', () => self.toggleOff());
};

NavigationPopup.prototype.initAnimation = function () {
  const self = this;

  self.animationTl = gsap
    .timeline({
      paused: true,
      reversed: true,
      onComplete: () => self.toggleState(),
      onReverseComplete: () => {
        self.toggleState();
        PubSub.publish('NavigationPopupItem__toggleOff');
      },
    })
    .set(self.options.$el, {
      visibility: "hidden",
      opacity: 0,
    })
    .to(
      self.options.$el, {
        visibility: 'visible',
        opacity: 1,
        duration: 0,
      },
    )
    .fromTo(
      self.$overlay, {
        visibility: 'hidden',
        opacity: 0,
      }, {
        visibility: 'visible',
        opacity: 1,
        ease: 'linear',
        duration: .3,
      },
    )
    .fromTo(self.$inner, {
      opacity: 0
    }, {
      opacity: 1,
      ease: "expo.out",
      duration: .4
    }, "<.2")
    .fromTo(
      self.$inner, {
        y: 100,
      }, {
        y: 0,
        ease: "back.out(1.8)",
        duration: .4,
      },
      '<',
    )
};

NavigationPopup.prototype.toggleState = function () {
  const self = this;

  self.options.isToggled = !self.options.isToggled;
};

NavigationPopup.prototype.toggleOn = function (speed = 1) {
  const self = this;

  if (self.options.isToggled || self.animationTl.isActive()) return;


  PubSub.publish("Hamburger__toggleOn");
  self.animationTl.timeScale(speed).play();
};

NavigationPopup.prototype.toggleOff = function (speed = 1.4) {
  const self = this;

  if (!self.options.isToggled || self.animationTl.isActive()) return;

  PubSub.publish("Hamburger__toggleOff");
  self.animationTl.timeScale(speed).reverse();
};

NavigationPopup.prototype.toggle = function () {
  const self = this;

  self.animationTl.reversed() ? self.toggleOn() : self.toggleOff();
};

export default NavigationPopup;